import { Interface, DataConnections } from "../../Models/Interface";
import { ProjectFormData } from "../../Models/ProjectFormData";
import { LicenseGroup } from "../../Models/LicenseGroup";
import { ProjectDailyJob } from "../../Models/ProjectDailyJobs";

export interface IProjectModalState {
  project?: ProjectFormData;
  licenses?: LicenseGroup;
  dailyjobs?: ProjectDailyJob[];
  interfaces_old?: Interface[];
  dataconnections?: DataConnections;
  loaded: boolean;
  errorCode?: string | null;
}

export const initialProjectModalState: IProjectModalState = {
  project: {} as ProjectFormData,
  licenses: undefined,
  dailyjobs: undefined,
  interfaces_old: undefined,
  dataconnections: undefined,
  loaded: false,
  errorCode: null,
};
